import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "board.svg",
  "use": "board.svg-usage",
  "viewBox": "0 0 2000 740",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 2000 740\" id=\"board.svg\"><defs><clipPath id=\"board.svg_a\"><rect width=\"2000\" height=\"740\" style=\"fill:none\" /></clipPath></defs><g style=\"clip-path:url(#board.svg_a)\"><polygon points=\"2410 981.76 1260.8 1649.46 -440 667.7 709.2 0 2410 981.76\" style=\"fill:#c5af8c\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol